define.alias("shared/errors/credentials", "media/errors/credentials");